module.exports = __webpack_public_path__ + "static/media/9_I wish you enough_SO.f8ba1a78.txt";